var map = {
	"./banner.png": 5580,
	"./charts.png": 376,
	"./emoji-crown.png": 2722,
	"./emoji-en.png": 5825,
	"./emoji-gallery.png": 7957,
	"./emoji-gift-bags.png": 4713,
	"./emoji-grinning-cat.png": 7687,
	"./emoji-highRise.png": 9485,
	"./emoji-key.png": 6879,
	"./emoji-man.png": 2590,
	"./emoji-papers.png": 2585,
	"./emoji-picture.png": 3614,
	"./emoji-ru.png": 1248,
	"./emoji-ruller.png": 4481,
	"./emoji-sad-cat.png": 5950,
	"./emoji-settings.png": 9492,
	"./emoji-smiling-cat-with-heart-eyes.png": 469,
	"./emoji-videocamera.png": 5323,
	"./emoji-weary-cat.png": 3048,
	"./emoji-women.png": 79,
	"./new-banners.png": 7647,
	"./roket-icon.png": 1314,
	"./smallCapture.png": 2609,
	"./suggestion-banner.png": 1043,
	"./tilda.png": 778
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6131;